export const JOBS_FILTERS = {
  STATUS: 'status',
  CLIENT: 'client',
  PACKAGE: 'package',
}
